module.exports = __webpack_public_path__ + "static/media/19.b0ff61f9.mp3";